'use client';

import React, { cloneElement, ReactElement } from 'react';
import { useUIStore } from '~/store';
import { useUsers } from '~/hooks/useUsers';

interface OnClickLoginProps {
  children?: React.ReactNode;
}

export function OnClickLogin({ children }: OnClickLoginProps) {
  const openLoginModal = useUIStore((state) => state.openLoginModal);

  return React.Children.map(children, (child) =>
    cloneElement(child as ReactElement<{ onClick?: () => void }>, {
      onClick: openLoginModal,
    })
  );
}

interface OnClickLogoutProps {
  children?: React.ReactNode;
}

export function OnClickLogout({ children }: OnClickLogoutProps) {
  const { signOut } = useUsers();

  return React.Children.map(children, (child) =>
    cloneElement(child as ReactElement<{ onClick?: () => void }>, {
      onClick: signOut,
    })
  );
}
